import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function CasinoPlayerActivityAPIRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers } = getRequestProps(ConnectionNames.casinoPlayerActivity, message);
    var url = `${baseUrl}${endpoint}`;
    if (typeof message.params !== "undefined") {
        url += `?platform=${message.params}`;
    }
    return new Request(url, {
        method,
        headers
    });
}
//# sourceMappingURL=CasinoPlayerActivityAPIRequestFormatter.js.map